module.exports = __webpack_public_path__ + "img/ep-&.ed489c71.jpg";